// extracted by mini-css-extract-plugin
export var button = "styles-module--button--iTk+u";
export var form = "styles-module--form--1ffvl";
export var input = "styles-module--input--O-JkE";
export var schemaLabel = "styles-module--schemaLabel--NbTCr";
export var tile = "styles-module--tile--1DWbW";
export var tiles = "styles-module--tiles--9lWs1";